import { Component, inject, Input } from '@angular/core'
import { PaymentPlan } from '@client/PaymentPlan'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardTitleComponent } from '@ui/Components/Card/CardTitle.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { NgStyle } from '@angular/common'
import { DateTimeComponent } from '@ui/Components/DateTime/DateTime.Component'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { BaseCurrencyComponent } from '@ui/Components/Currency/BaseCurrency.Component'
import Order from '@client/Order'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'
import { Router } from '@angular/router'

@Component({
	selector: 'payment-plan-confirmation',
	templateUrl: './PaymentPlanConfirmation.Component.html',
	imports: [
		CardComponent,
		CardTitleComponent,
		CardContentComponent,
		NgStyle,
		DateTimeComponent,
		BaseCurrencyComponent,
		RaisedButtonComponent,
	],
})
export class PaymentPlanConfirmationComponent {
	@Input() protected readonly order: Order

	@Input() protected readonly paymentPlan: PaymentPlan

	protected readonly systemConfigService: SystemConfigService

	private readonly router: Router

	constructor() {
		this.systemConfigService = inject(SystemConfigService)
		this.router = inject(Router)
	}

	protected readonly viewOrders = () => {
		this.router.navigateByUrl('/my-account/orders')
	}
}
